import { minutesToMilliseconds } from "date-fns";

import {
	getAdminSettingsHomeBranding,
	getAdminSettingsHomeFunctions,
	getAdminSettingsHomeSeatUsage,
	getAdminSettingsHomeSettings,
} from "../../services";

const queryScope = (companyId?: string) => companyId ?? "self";

// FF-gated queries: when the admin-settings-home refresh FF is off for the target
// company the internal-api returns 403; suppress the default toast and don't retry.
const FF_GATED_META = { disableDefaultErrorHandling: true } as const;

export const adminSettingsHomeSeatUsageQuery = (companyId?: string) => ({
	queryKey: ["admin-settings-home", queryScope(companyId), "seat-usage"],
	queryFn: () => getAdminSettingsHomeSeatUsage(companyId),
	staleTime: minutesToMilliseconds(1),
	retry: false,
	meta: FF_GATED_META,
});

export const adminSettingsHomeBrandingQuery = (companyId?: string) => ({
	queryKey: ["admin-settings-home", queryScope(companyId), "branding"],
	queryFn: () => getAdminSettingsHomeBranding(companyId),
	retry: false,
	meta: FF_GATED_META,
});

export const adminSettingsHomeFunctionsQuery = (companyId?: string) => ({
	queryKey: ["admin-settings-home", queryScope(companyId), "functions"],
	queryFn: () => getAdminSettingsHomeFunctions(companyId),
	retry: false,
	meta: FF_GATED_META,
});

export const adminSettingsHomeSettingsQuery = (companyId?: string) => ({
	queryKey: ["admin-settings-home", queryScope(companyId), "settings"],
	queryFn: () => getAdminSettingsHomeSettings(companyId),
	retry: false,
	meta: FF_GATED_META,
});
